<template>
    <header class="block relative z-50 bg-white" role="banner" aria-label="Site header">
        <nav class="flex relative z-30 justify-end items-center px-4 py-3 mx-auto max-w-container md:py-3 sm-max:px-3 lg:items-center" role="navigation" aria-label="Main navigation">
            <div class="block flex-grow">
                <a href="/" aria-label="Go to homepage">
                    <nuxt-img 
                        class="sm-max:w-40" 
                        preload 
                        format="webp" 
                        width="174" 
                        height="71" 
                        :src="logoSrc" 
                        :alt="logoAlt"
                        loading="eager"
                        fetchpriority="high"
                    />
                </a>
            </div>
            <a 
                :href="phoneHref"
                class="border bnt-basic xs-max:text-14 !py-3 sm-max:px-3 !text-base" 
                :style="{ color: primaryColor, borderColor: primaryColor }"
                aria-label="Call us at {{ phoneText }}"
                role="link"
            >
                <span v-html="phoneText" aria-hidden="true"></span>
            </a>
            <button 
                type="button" 
                @click="scrollTo(scrollTarget,scrollPosition(mobilePosition))"
                :style="{ background: primaryColor }"
                class="ml-6 text-white bnt-basic !py-3 !capitalize xs-max:text-14 md-max:px-8 sm-max:px-3 sm-max:ml-3 lg:!ml-4 lg:!px-6 md:!block !hidden md:!text-base"
                :aria-label="`${buttonText} - Navigate to ${scrollTarget} section`"
                aria-describedby="button-description"
            >
                <span v-html="buttonText" aria-hidden="true"></span>
            </button>
            <span id="button-description" class="sr-only">This button will scroll to the products section of the page</span>
        </nav>
    </header>
</template>

<script setup>

const props = defineProps({
    logoSrc: {
        type: String,
        default: "/assets/images/logo.png"
    },
    logoAlt: {
        type: String,
        default: "Lifeboost Coffee Logo"
    },
    scrollTarget: {
        type: String,
        default: "the-products"
    },
    phoneHref: {
        type: String,
        default: "tel:1-800-479-1596"
    },
    phoneText: {
        type: String,
        default: "1-800-479-1596"
    },
    buttonText: {
        type: String,
        default: "Try It Risk-Free Today"
    },
    primaryColor: {
        type: String,
        default: "#e28831" // Това е примерна стойност за lifeboost-orange-middle
    },
    mobilePosition: {
        type: String,
        default: 'bottom'
    }
})

defineBuilderComponent({
    friendlyName: "Basic Header",
    inputs: [
        {
            name: "primaryColor",
            type: "color",
            defaultValue: "#e28831"
        },
        {
            name: "logoSrc",
            type: "file",
            allowedFileTypes: ["jpeg", "jpg", "svg", "png"],
            defaultValue: "/assets/images/black-logo.svg"
        },
        {
            name: "logoAlt",
            type: "text",
            defaultValue: "Lifeboost Coffee Logo"
        },
        {
            name: "phoneHref",
            type: "text",
            defaultValue: "tel:1-800-479-1596"
        },
        {
            name: "scrollTarget",
            type: "text",
            defaultValue: "the-products"
        },
        {
            name: 'mobilePosition',
            type: 'enum',
            friendlyName: 'Scroll Position mobile',
            enum: [
                { label: 'Bottom', value: 'bottom' },
                { label: 'Top', value: 'top' }
            ],
            defaultValue: 'Bottom'
        },
        {
            name: "phoneText",
            type: "text",
            defaultValue: "1-800-479-1596"
        },
        {
            name: "buttonText",
            type: "text",
            defaultValue: "Try It Risk-Free Today"
        },]
})

</script>

<style scoped>
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}
</style>